import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useContext,
} from "react"
import {
  Container,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
  Input,
} from "reactstrap"
import "react-multi-carousel/lib/styles.css"
import { Link, useParams, useLocation, useNavigate } from "react-router-dom"
import classnames from "classnames"
import awicon from "../../assets/images/services-icon/coin.png"
import duration from "../../assets/images/services-icon/duration.png"
import Select from "react-select"
import { SECURITY_KEY, BASE_URL } from "../../global"
import dsmile from "../../assets/images/services-icon/dog_smile.png"
import axios from "axios"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import moment from "moment"
import Loader from "react-spinner-loader"
import Comprehension from "./assessment/Comprehension"
import Pagination from "./assessment/Pagination"
import {
  MathJax,
  MathJaxContext,
  MathJaxBaseContext,
} from "better-react-mathjax"
import { useIframeIdleDetection } from "../../modules/online-lesson/iframe-idle-detection"
import StreakBadge from "../Utility/Streakbadge"
import CircularTimer from "../../../src/pages/Utility/Circulartimer"
//import { OVERLAY_HEADER_FONT_PX } from "../Utility/OverlayOptions"
import { useOverlayStyle } from "../Utility/useOverlayStyle"


const STREAK_STORAGE_KEY = "student_answer_streak"
const BEST_STREAK_STORAGE_KEY = "student_best_streak"

const getStoredStreak = () => {
  const raw = localStorage.getItem(STREAK_STORAGE_KEY)
  return raw !== null ? parseInt(raw) || 0 : 0
}

const getStoredBestStreak = () => {
  const raw = localStorage.getItem(BEST_STREAK_STORAGE_KEY)
  return raw !== null ? parseInt(raw) || 0 : 0
}

const persistStreak = (value, authUser, onBestStreak) => {
  localStorage.setItem(STREAK_STORAGE_KEY, String(value))
  const nextBest = Math.max(getStoredBestStreak(), value)
  localStorage.setItem(BEST_STREAK_STORAGE_KEY, String(nextBest))
  if (typeof onBestStreak === "function") {
    onBestStreak(nextBest)
  }
  if (authUser) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
    axios
      .post(BASE_URL + "studentAnswer/UpdateStreak", { streak: value })
      .then(response => {
        const apiBest = Number(response?.data?.best_streak)
        if (Number.isFinite(apiBest)) {
          localStorage.setItem(BEST_STREAK_STORAGE_KEY, String(apiBest))
          if (typeof onBestStreak === "function") {
            onBestStreak(apiBest)
          }
        }
      })
      .catch(error => {
        // Non-critical — localStorage already has the latest value,
        // this just syncs it to tbl_student for cross-device/session load
        console.log("Streak sync failed:", error)
      })
  }
}

// ─── Calculate streak from LessonActivitiesQuestions ──────────────────────
// Reads StudentAnsAttempts for each question part in chronological order
// (sorted by created_on), then walks from the LAST answered question backward
// to find the current consecutive correct streak.
//
// Logic per part attempt:
//   points_obtained > 0  → correct
//   points_obtained === 0 → wrong
//   StudentAnsAttempts empty → not yet answered (stop counting backward)
//
// We build a flat timeline of answered parts sorted by created_on,
// then count consecutive correct answers from the end.
// const calculateStreakFromData = (lessonActivitiesQuestions, reTrySkipQuestion) => {
//   if (!lessonActivitiesQuestions || lessonActivitiesQuestions.length === 0)
//     return 0

//   // Flatten all attempted parts into a single timeline with timestamps
//   const timeline = []

//   if (reTrySkipQuestion) {
//     timeline.push(reTrySkipQuestion)
//   }

//   lessonActivitiesQuestions.forEach(question => {
//     const subId = parseInt(question.fk_sub_id)

//     if (
//       subId === 1 &&
//       question.english_question &&
//       question.english_question.length > 0
//     ) {
//       question.english_question.forEach(eq => {
//         if (eq.english_question_parts && eq.english_question_parts.length > 0) {
//           eq.english_question_parts.forEach(part => {
//             if (part.StudentAnsAttempts && part.StudentAnsAttempts.length > 0 && part?.StudentQusSkip?.length === 0) {
//               // Take the LATEST attempt for this part
//               const sorted = [...part.StudentAnsAttempts].sort(
//                 (a, b) => new Date(b.created_on) - new Date(a.created_on)
//               )
//               const latest = sorted[0]
//               const totalMark = part.StudentAnsAttempts.reduce(
//                 (sum, att) =>
//                   sum +
//                   (att.points_obtained != null
//                     ? parseInt(att.points_obtained)
//                     : 0),
//                 0
//               )
//               timeline.push({
//                 created_on: latest.created_on,
//                 // Correct if total points > 1 across all attempts for this part
//                 isCorrect: totalMark > 1,
//               })
//             }else if (part?.StudentQusSkip?.length > 0) {
//               timeline.push({
//                 created_on: part?.StudentQusSkip?.[0]?.created_on || new Date().toISOString(),
//                 isCorrect: false, // Skipped parts are considered incorrect for streak purposes
//               })
//             }
//           })
//         }
//       })
//     } else if (
//       subId === 2 &&
//       question.question &&
//       question.question.length > 0
//     ) {
//       question.question.forEach(q => {
//         if (q.question_parts && q.question_parts.length > 0) {
//           q.question_parts.forEach(part => {
//             if (part.StudentAnsAttempts && part.StudentAnsAttempts.length > 0 && part?.StudentQusSkip?.length === 0) {
//               const sorted = [...part.StudentAnsAttempts].sort(
//                 (a, b) => new Date(b.created_on) - new Date(a.created_on)
//               )
//               const latest = sorted[0]
//               const totalMark = part.StudentAnsAttempts.reduce(
//                 (sum, att) =>
//                   sum +
//                   (att.points_obtained != null
//                     ? parseInt(att.points_obtained)
//                     : 0),
//                 0
//               )
//               timeline.push({
//                 created_on: latest.created_on,
//                 isCorrect: totalMark > 1,
//               })
//             }else if (part?.StudentQusSkip?.length > 0) {
//               timeline.push({
//                 created_on: part?.StudentQusSkip?.[0]?.created_on || new Date().toISOString(),
//                 isCorrect: false, // Skipped parts are considered incorrect for streak purposes
//               })
//             }
//           })
//         }
//       })
//     }
//   })


//   if (timeline.length === 0) return 0

//   // Sort all answered parts chronologically (oldest → newest)
//   timeline.sort((a, b) => new Date(a.created_on) - new Date(b.created_on))

//   // Count consecutive correct answers from the END of the timeline
//   let streak = 0
//   for (let i = timeline.length - 1; i >= 0; i--) {
//     if (timeline[i].isCorrect) {
//       streak++
//     } else {
//       break // Stop at first wrong answer
//     }
//   }

//   return streak
// }

// ─── Main Assessment Component ─────────────────────────────────────────────
const Assessment = React.memo(() => {
  const { key } = useParams()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const type = searchParams.get("type") || null
  const homework = searchParams.get("homework") || null

  let pk_activity_key = null
  let IsType = null
  let IsHomework = null
  if (
    key &&
    key.length >= 16 &&
    type &&
    type != null &&
    homework &&
    homework != null
  ) {
    pk_activity_key = key
    IsType = type
    IsHomework = homework
  } else {
    window.history.back()
  }

  const [seconds, setSeconds] = useState(0)
  const [isRunning, setIsRunning] = useState(false)
  const [SkipQuestionTotal, setSkipQuestionTotal] = useState(0)

  // ─── Streak: computed from LessonActivitiesQuestions on every data load ──
  //const [answerStreak, setAnswerStreak] = useState(0)
  const [answerStreak, setAnswerStreak] = useState(() => getStoredStreak())
  const [bestStreak, setBestStreak] = useState(() =>
    Math.max(getStoredBestStreak(), getStoredStreak())
  )
  const [reTrySkipQuestion, setReTrySkipQuestion] = useState(null)

  const [coinsEarned, setCoinsEarned] = useState(0)

  useEffect(() => {
    let timer
    if (isRunning) {
      timer = setInterval(() => setSeconds(prev => prev + 1), 1000)
    }
    return () => clearInterval(timer)
  }, [isRunning])

  const formatTime = time => {
    const m = Math.floor(time / 60)
    const s = time % 60
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`
  }

  const handleResetTimer = () => {
    setSeconds(0)
    setIsRunning(true)
  }

  const [loader, setLoader] = useState(false)
  const [ActivityData, setActivityData] = useState([])
  const [TopicData, setTopicData] = useState(null)
  const [activityKey, setKey] = useState(0)
  const [ActivityPart, setActivityPart] = useState(null)
  const [ActiviteQAData, setActivityQAData] = useState([])
  const [otherData, setOtherData] = useState([])
  const [AnswerData, setAnswerData] = useState([])
  const [submitOtherData, setSubmitOtherData] = useState(null)

  const authUser = JSON.parse(localStorage.getItem("authStudentUser")) || null
  const navigate = useNavigate()

  useEffect(() => {
    fetchData()
  }, [location])

  // ─── Recompute streak whenever ActivityData changes (covers page refresh) ─
  useEffect(() => {
    // if (
    //   ActivityData &&
    //   ActivityData.LessonActivitiesQuestions &&
    //   ActivityData.LessonActivitiesQuestions.length > 0
    // ) {
    //   const streak = calculateStreakFromData(
    //     ActivityData.LessonActivitiesQuestions, reTrySkipQuestion
    //   )
    //   setAnswerStreak(streak)
    // } else {
    //   //setAnswerStreak(0)
    // }

    if(ActivityData?.coins_earned){
      setCoinsEarned(ActivityData?.coins_earned)
    }
  }, [ActivityData])

  const fetchAttendanceData = async () => {
    if (authUser && pk_activity_key) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
      axios
        .post(BASE_URL + "studentSession/StudentAttendance", {
          pk_activity_key,
        })
        .catch(error => {
          if (
            (error?.response?.status === 403 ||
              error?.response?.status === 401) &&
            (error?.response?.data?.error === "jwt expired" ||
              error?.response?.data?.error === "invalid algorithm" ||
              error?.response?.data?.error === "invalid token")
          ) {
            localStorage.clear()
            navigate("/login")
          }
        })
    } else {
      window.history.back()
    }
  }

  const fetchData = async () => {
    if (authUser && pk_activity_key) {
      setLoader(true)
      setActivityData([])
      setActivityPart(null)
      setActivityQAData([])
      setOtherData([])
      setAnswerData([])
      setSubmitOtherData(null)
      axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
      axios
        .post(BASE_URL + "studentSession/StudentAssessmentQuestions", {
          pk_activity_key,
          subject_id: type,
        })
        .then(res => {
          setLoader(false)
          if (res.data.LessonActivitiesQuestions.length > 0) {
            res.data.LessonActivitiesQuestions.forEach(q => {
              if (
                q.fk_sub_id &&
                parseInt(q.fk_sub_id) === 1 &&
                q.english_question &&
                q.english_question.length === 0
              ) {
                toast.error("Question data not found", {
                  autoClose: 3000,
                  onClose: () => history.back(),
                })
              } else if (
                q.fk_sub_id &&
                parseInt(q.fk_sub_id) === 2 &&
                q.question &&
                q.question.length === 0
              ) {
                toast.error("Question data not found", {
                  autoClose: 3000,
                  onClose: () => history.back(),
                })
              }
            })
            setActivityData(res.data)
            setTopicData(res.data.activity_node[0])
            handleResetTimer()
            if (parseInt(IsHomework) !== 1) fetchAttendanceData()
          } else {
            toast.error("Question data not found", {
              autoClose: 3000,
              onClose: () => history.back(),
            })
            setActivityData([])
            setTopicData(null)
          }
        })
        .catch(error => {
          setLoader(false)
          if (
            (error?.response?.status === 403 ||
              error?.response?.status === 401) &&
            (error?.response?.data?.error === "jwt expired" ||
              error?.response?.data?.error === "invalid algorithm" ||
              error?.response?.data?.error === "invalid token")
          ) {
            localStorage.clear()
            navigate("/login")
          }
        })
    } else {
      setLoader(false)
      window.history.back()
    }
  }

  const CountTotalCoins = question => {
    let total_coins = 0
    if (question && question.length > 0) {
      question.forEach(activity => {
        if (activity.fk_sub_id === "1") {
          if (
            activity.english_question &&
            (parseInt(
              activity.english_question[0].english_question_category_id
            ) === 10 ||
              parseInt(
                activity.english_question[0].english_question_category_id
              ) === 13)
          ) {
            activity.english_question.map(q => {
              let arr = q.english_question_parts.filter(
                p =>
                  p.english_question_answers.length > 0 &&
                  p.english_question_answers[0].english_answer_text &&
                  p.english_question_answers[0].english_answer_text !== ""
              )
              total_coins += arr.length * 2 || 0
            })
          } else {
            total_coins += activity.english_question?.reduce(
              (acc, q) => acc + q.english_question_parts?.length * 2,
              0
            )
          }
        } else if (activity.fk_sub_id === "2" || activity.fk_sub_id === "3") {
          total_coins += activity.question?.reduce(
            (acc, q) => acc + q.question_parts?.length * 2,
            0
          )
        }
      })
    }
    return total_coins
  }

  // ─── After submit: re-fetch data so streak recalculates from ground truth ─
  // The streak is ALWAYS derived from LessonActivitiesQuestions, never
  // incremented locally — this ensures refresh always shows correct state.
  const onSubmitedAnswer = Answer => {
    const activePayload = otherData && otherData.data
    if (authUser && pk_activity_key && Answer.length > 0 && activePayload?.activeData) {
      let IsFirstQuestion = activePayload.IsFirstQuestion || 0
      let IsLastQuestion = activePayload.IsLastQuestion || 0
      let ActiveData = activePayload.activeData
      axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
      axios
        .post(BASE_URL + "studentAnswer/submitQuestionAssessment", {
          topic_id: ActiveData.topic_id,
          answer_text: Answer,
          is_first_question: IsFirstQuestion === 1,
          is_last_question: IsFirstQuestion === IsLastQuestion,
          lesson_activity_key: ActiveData.fk_lesson_activity_key,
          lesson_key: ActiveData.fk_lesson_key,
          part_id: Answer[0].part_id,
          is_skip: Answer[0].is_skip,
          question_id: ActiveData.fk_question_id,
          question_length: IsLastQuestion,
          question_no: IsFirstQuestion,
          sest_key: ActivityData.fk_sest_key,
          subject_id: ActiveData.fk_sub_id,
          submitted_on: seconds,
        })
        .then(async res => {
          setAnswerData(null)
          const payload = res.data
          if (Array.isArray(payload) && payload.length > 0) {
            setSubmitOtherData(payload[0])

            const pts = parseInt(payload[0]?.points ?? 0)
            const isCorrect = parseInt(payload[0]?.is_correct ?? 0)
            const isautomark = parseInt(payload[0]?.is_auto_mark ?? 0)

            if (isautomark == 0) {
              // skip streak for manual mark
            } else if (Answer[0].is_skip == 1) {
              setAnswerStreak(prev => {
                const next = 0
                persistStreak(next, authUser, setBestStreak)
                return next
              })
            } else {
              setAnswerStreak(prev => {
                const next = pts > 1 && isCorrect !== 3 ? prev + 1 : 0
                persistStreak(next, authUser, setBestStreak)
                return next
              })
            }
            setCoinsEarned(prev =>
              pts >= 1 && isCorrect === 1
                ? Number(prev) + Number(pts)
                : prev
            )
          } else if (parseInt(res.data) === 1) {
            fetchData()
          }
        })
        .catch(error => {
          setAnswerData(null)
          window.history.back()
          console.log(error)
          if (
            (error?.response?.status === 403 ||
              error?.response?.status === 401) &&
            (error?.response?.data?.error === "jwt expired" ||
              error?.response?.data?.error === "invalid algorithm" ||
              error?.response?.data?.error === "invalid token")
          ) {
            localStorage.clear()
            navigate("/login")
          }
        })
    } else {
      window.history.back()
    }
  }

  const handleFunctionTrigger = useCallback(() => fetchData(), [isRunning])

  const handleSubmitFunction = useCallback(
    Answer_data => {
      if (Answer_data && Answer_data != null && Answer_data.length > 0) {
        setOtherData(prev => ({ ...prev, Answer_data }))
        setAnswerData(Answer_data)
      }
    },
    [otherData]
  )

  useEffect(() => {
    if (AnswerData && AnswerData != null && AnswerData.length > 0)
      onSubmitedAnswer(AnswerData)
  }, [AnswerData])

  const handleSetActiveData = useCallback(
    data => {
      setActivityQAData({
        ...data.activeData,
        is_last_question: data.IsLastQuestion,
        is_first_question: data.IsFirstQuestion,
        is_total_tab: data.IsTotalTab,
        is_current_tab: data.IsCurrentTab,
        is_current_tab_total_part: data.IsCurrentTabTotalPart,
        is_current_tab_current_part: data.IsCurrentTabCurrentPart,
        is_show_all_parts: data.ShowAllParts ? 1 : 0,
        IsHomework,
      })
      setActivityPart(data.ActivityPartData)
      setOtherData(prev => ({ ...prev, data }))
    },
    [isRunning]
  )

  const handleSkipQuestionTotal = data => setSkipQuestionTotal(data)

  const handleHomeworkClick = () => {
    const filterState = location?.state || ""
    navigate("/homework-list", { state: { filterState } })
  }

  useIframeIdleDetection()

  // const overlayOptions = {
  //   position:   "relative",
  //   fontSize:   OVERLAY_HEADER_FONT_PX[localStorage.getItem("ov_fontstep")] + "px",
  //   fontFamily: localStorage.getItem("ov_fontfamily"),
  // }

  const { cardHeaderStyle } = useOverlayStyle("ov");

  // ─── Fit the question box to the space left under the header/tabs ────────
  // The header height varies (title length, font step, screen scaling), so a
  // fixed calc() offset lets the box run off the bottom on laptops/tabs.
  // Measure where the box starts (--qc-top / --qcc-top) and how tall the
  // Skip/Submit row under it is (--qc-bottom), and expose them to CSS.
  const pageRef = useRef(null)
  const questionMathRef = useRef(null)
  const mathJaxContext = useContext(MathJaxBaseContext)

  // The MathJax wrapper below is not dynamic, so it only typesets on mount.
  // Question text, shuffled MCQ options and feedback all render after that,
  // so typeset again whenever new text containing a backtick (the AsciiMath
  // delimiter) lands inside the question area. MathJax output never contains
  // a backtick, and typing into an answer box changes input values rather
  // than the DOM, so neither triggers this.
  useEffect(() => {
    const root = questionMathRef.current
    if (!root || !mathJaxContext?.promise) return

    let timer = null
    let queue = Promise.resolve()
    let cancelled = false

    const typeset = () => {
      queue = queue
        .then(() => mathJaxContext.promise)
        .then(mathJax => {
          if (!cancelled) return mathJax.typesetPromise([root])
        })
        .catch(() => {})
    }

    const hasMath = node => (node.textContent || "").includes("`")

    const observer = new MutationObserver(mutations => {
      const relevant = mutations.some(m =>
        m.type === "characterData"
          ? hasMath(m.target)
          : [...m.addedNodes].some(hasMath)
      )
      if (!relevant) return
      clearTimeout(timer)
      timer = setTimeout(typeset, 30)
    })
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    })
    typeset()

    return () => {
      cancelled = true
      clearTimeout(timer)
      observer.disconnect()
    }
  }, [mathJaxContext])

  useEffect(() => {
    const page = pageRef.current
    if (!page) return
    let frame = null

    const setTop = (selector, name) => {
      const el = page.querySelector(selector)
      if (el) {
        const top = Math.round(el.getBoundingClientRect().top + window.scrollY)
        page.style.setProperty(name, `${top}px`)
      }
    }
    const measure = () => {
      frame = null
      setTop(".question_container", "--qc-top")
      setTop(".question-container-custom", "--qcc-top")
      const row = page.querySelector(".skip-submit-row")
      const rowHeight = row
        ? row.getBoundingClientRect().height +
          parseFloat(getComputedStyle(row).marginTop || 0)
        : 0
      page.style.setProperty("--qc-bottom", `${Math.round(rowHeight)}px`)
    }
    const schedule = () => {
      if (frame === null) frame = requestAnimationFrame(measure)
    }

    const observer = new ResizeObserver(schedule)
    observer.observe(page)
    Array.from(page.children).forEach(child => observer.observe(child))
    window.addEventListener("resize", schedule)
    schedule()

    return () => {
      observer.disconnect()
      window.removeEventListener("resize", schedule)
      if (frame !== null) cancelAnimationFrame(frame)
    }
  }, [])

  return (
    <React.Fragment>
      <Loader show={loader} type="body" />
      <ToastContainer autoClose={3000} />

      <div className="page-wrapper">
        <div className="cs-pg-header bg-dark-blue py-4">
          <Container className="custom-wt" style={cardHeaderStyle}>
            <div className="d-flex align-items-center">
              <div className="mt-0 border-right me-4" style={{ width: "20%" }}>
                {parseInt(IsHomework) === 1 ? (
                  <div
                    className="text-white  text-uppercase cursor-pointer"
                    onClick={handleHomeworkClick}
                  >
                    <span>
                      <i className=" fas fa-chevron-left me-1"></i>
                    </span>{" "}
                    BACK TO HOMEWORK
                  </div>
                ) : (
                  <div
                    className="text-white  text-uppercase"
                    onClick={() => history.back()}
                  >
                    <span>
                      <i className=" fas fa-chevron-left me-1"></i>
                    </span>{" "}
                    Back
                  </div>
                )}
              </div>
              <div className="d-flex align-items-center justify-content-between flex-grow-1 gap-3">
                <div
                  className="mb-0  text-white w-60 fw-regular fw-500 assessment-title"
                  title={
                    (ActivityData?.activity_type === 0 && TopicData?.node_name) ||
                    (ActivityData?.activity_type === 8 && TopicData?.name) ||
                    undefined
                  }
                >
                  {ActivityData?.activity_type === 0 &&
                    TopicData?.node_name?.trim() &&
                    TopicData.node_name}
                  {ActivityData?.activity_type === 8 &&
                    TopicData?.name?.trim() &&
                    TopicData.name}
                </div>
                <p className="mb-0 text-uppercase luminous-wht text-end" style={{
                  transform: "scale(0.9)",
                  transformOrigin: "top center",
                }}>
                  <span className="text-yellow me-1">
                    {ActivityData?.subject_name ?? null}
                  </span>{" "}
                  <span className="text-nowrap">
                    {ActivityData?.activity_type === 8
                      ? "Summative"
                      : "Online Activities"}
                  </span>
                </p>

                {/* ── Current + Best streak badges (persist across refresh) ── */}
                <StreakBadge streak={answerStreak} label="Current Streak" />
                <StreakBadge streak={bestStreak} label="Best Streak" />

                <div className="coins-badge">
                  <img width={24} src={awicon} alt="" />
                  <div className="coins-badge__info">
                    <span className="coins-badge__count">
                      {coinsEarned ?? ActivityData?.coins_earned}/
                      {ActivityData?.LessonActivitiesQuestions?.length > 0
                        ? CountTotalCoins(ActivityData.LessonActivitiesQuestions)
                        : 0}
                    </span>
                    <span className="coins-badge__label">coins</span>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>

        <Container className="custom-wt">
          <div className="assessement-section summary-width-hold mt-2">
            <div className="d-flex justify-content-center align-items-center">
              <Nav tabs className="nav-tabs-custom nav-tabs-new mb-0">
                <Pagination
                  ActivityData1={ActivityData.LessonActivitiesQuestions}
                  keyData={activityKey}
                  triggerSetActiveData={handleSetActiveData}
                  triggerSkipQuestionTotal={handleSkipQuestionTotal}
                />
              </Nav>

              {isRunning &&
              ActivityPart != null &&
              ActiviteQAData != null &&
              parseInt(ActivityData.tut_clock_is_active) != 1 ? (
                <div className="custom-timer d-flex align-items-center">
                  <CircularTimer duration={seconds} />
                </div>
              ) : null}
            </div>
            <p className="font-size-16 fw-semibold mb-2 mt-2">
              {ActivityData?.marked_for_homework >= 0 && (
                <>
                  {ActivityData?.homework_tutor_message &&
                  ActivityData.marked_for_homework == 1 ? (
                    <>
                      <b>Tutor message:</b>{" "}
                      {ActivityData.homework_tutor_message}
                    </>
                  ) : ActivityData?.lesson_tutor_message ? (
                    <>
                      <b>Tutor message:</b> {ActivityData.lesson_tutor_message}
                    </>
                  ) : null}
                </>
              )}
            </p>
            <p className="font-size-16 fw-semibold mb-2">
              {ActivityData?.tutor_comments && (
                <>
                  <b>Tutor comments:</b> {ActivityData.tutor_comments}
                </>
              )}
            </p>

            <div ref={questionMathRef}>
              <MathJax
                inline
                dynamic={false}
                key={`${ActiviteQAData?.fk_question_id || ""}:${
                  ActivityPart?.[0]?.english_question_part_id ||
                  ActivityPart?.[0]?.part_id ||
                  ""
                }`}
              >
                <Comprehension
                  triggerFunction={handleFunctionTrigger}
                  triggerSubmitFunction={handleSubmitFunction}
                  data={ActiviteQAData}
                  part={ActivityPart}
                  responceData={submitOtherData}
                  skipQuestionData={SkipQuestionTotal}
                  activitykey={ActivityData?.pk_lesson_activity_key}
                  activityLevel={ActivityData?.level_name}
                  setReTrySkipQuestion={setReTrySkipQuestion}
                />
              </MathJax>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
})

export default Assessment
